import { isUndNullEmp } from '../../../helpers/main';

export class NotificationToast {
    constructor(
        _controller = '',
        _method = '',
        _isActive = true,
        _isAuthenticated = true,
    ) {
        this.controller = _controller;
        this.method = _method;
        this.isActive = _isActive;
        this.isAuthenticated = _isAuthenticated;
    }

    static getClassTitle = () => {
        return 'NotificationToast - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Controller: 2,
                    Method: 2,
                    IsActive: 1,
                    IsAuthenticated: 1,
                },
                max: {
                    Controller: 100,
                    Method: 100,
                    IsActive: 1,
                    IsAuthenticated: 1,
                }
            };
        } else {
            return {
                min: {
                    controller: 2,
                    method: 2,
                    isActive: 1,
                    isAuthenticated: 1,
                },
                max: {
                    controller: 100,
                    method: 100,
                    isActive: 1,
                    isAuthenticated: 1,
                }
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassTitle() })?.result) {
            if (upperCase) {
                return new NotificationToast(
                    obj.Controller,
                    obj.Method,
                    obj.IsActive,
                    obj.IsAuthenticated,
                );
            } else {
                return new NotificationToast(
                    obj.controller,
                    obj.method,
                    obj.isActive,
                    obj.isAuthenticated,
                );
            }
        } else {
            return new NotificationToast();
        }
    }
}